module.exports = __webpack_public_path__ + "img/answer1-17.698afc2d.png";